'use client';
import Image from 'next/image';
import { useMedia } from 'react-use';

interface VideoPlayerProps {
  className?: string;
  controls?: boolean;
  gif?: string;
  height?: number | string;
  loop?: boolean;
  muted?: boolean;
  poster?: string;
  preload?: 'auto' | 'metadata' | 'none';
  showDebug?: boolean;
  sources: Array<{
    src: string;
    type?: string;
  }>;
  width?: number | string;
}

export default function VideoPlayer({
  sources,
  controls = true,
  muted = true,
  loop = false,
  className = '',
  width = '100%',
  height = 'auto',
  preload = 'metadata',
  gif,
  poster,
  showDebug = process.env.NODE_ENV === 'development',
}: VideoPlayerProps) {
  const isTablet = useMedia('(min-width: 768px)', false);
  const showingGif = !isTablet && gif;

  return (
    <div className="relative">
      {showDebug && (
        <div className="absolute right-2 top-2 z-10 rounded bg-black/70 px-2 py-1 text-xs text-white">
          {showingGif ? 'GIF' : 'VIDEO'}
        </div>
      )}

      {showingGif ? (
        <Image
          src={gif}
          alt=""
          width={typeof width === 'number' ? width : 800}
          height={typeof height === 'number' ? height : 600}
          className={className}
          style={{ objectFit: 'cover' }}
          unoptimized
        />
      ) : (
        <video
          controls={controls}
          autoPlay={isTablet && muted}
          muted={muted}
          loop={loop}
          width={width}
          height={height}
          preload={preload}
          className={className}
          playsInline
          poster={poster}
          aria-hidden="true"
          tabIndex={-1}
        >
          {sources.map((source, index) => (
            <source key={index} src={source.src} type={source.type || 'video/mp4'} />
          ))}
        </video>
      )}
    </div>
  );
}
